/** @description 页面公共组件 */
import React from 'react';
import { Prompt } from 'umi';

const PageMain: React.FC<{ isPrompt: boolean }> = ({ children, isPrompt }) => {
  const mainStyle = {
    background: '#fff',
    padding: 20,
    borderRadius: 10,
  } as React.CSSProperties;
  const containerStyle = {
    padding: 20,
    minHeight: 'calc(100vh - 48px)',
  } as React.CSSProperties;

  return (
    <div style={containerStyle}>
      <Prompt when={isPrompt} message="你确定要离开吗？" />
      <main style={mainStyle}>{children}</main>
    </div>
  );
};

export default PageMain;
